import { AdaptSliceState, localAdaptSelectors } from "../../adapt/adaptSlice";
import GenericSelectors from "./genericSelectors";

export class CommonAdaptSelectors extends GenericSelectors<AdaptSliceState, typeof localAdaptSelectors> {
    constructor() {
        super(localAdaptSelectors);
    }
}
